export const environment = {

    production: true,
    version: '1' + '-dev',
    // defaultLanguage: 'en-US',
    // ###############################################
    serverUrl: 'https://alexcoc.apps.softprograms-eg.com',
  
    grantType: 'client_credentials',
    // clientId: 'alexcoc:public-website',
    clientId: 'acer:default',
    clientSecret: 'yxay9kub55ieffjtmghwietuh1dqvcucznvvclxmaeix',  
    scope: 'squidex-api',
    defaultLanguage: 'ar',
    supportedLanguages: ['en', 'ar'],




};
